import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

const Included: FC = () => {
  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        py: { xs: 4, lg: 8 },
        height: '362px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { lg: 'row', xs: 'column' },
          justifyContent: 'center',
          background: 'linear-gradient(-90deg, #224267, #15183A)',
          borderRadius: '67px',
          width: '90%',
          marginTop: { xs: 8, sm: '-8px' },
        }}
      >
        <Box
          sx={{
            alignSelf: 'center',
            px: 4,
            py: { xs: 4, lg: 0 },
            textAlign: { xs: 'center', lg: 'left' },
          }}
        >
          <Typography
            color="white"
            sx={{
              fontFamily: 'Roboto',
              fontSize: { lg: '50px', xs: '35px' },
              lineHeight: '50px',
              fontWeight: 'medium',
            }}
          >
            Todo a la medida
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: { lg: '50px', xs: '35px' },
              lineHeight: '50px',
              fontWeight: '600',
              color: '#F9D00A',
            }}
          >
            de tu negocio
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};

export default Included;
